import React from 'react';
import { ContractedQuoteInfoOutDTO } from '@api/ringil-api.v2.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { formatPrice } from '@utils/priceUtils.ts';
import { isNullOrUndefined } from '@utils/utils.tsx';

interface ComponentProps {
  contracted: ContractedQuoteInfoOutDTO;
  dataTestId?: string;
}

/**
 * Contracted unit prices of the CONTRACTED distribution, one line per manipulation unit of the shipment:
 * "FBU: 620 CZK / jedn. (Ladenfactor 4)" or "(Výchozí)" for the default row.
 */
const ContractedPriceRows: React.FC<ComponentProps> = ({ contracted, dataTestId = 'carrier-demand-contracted-prices' }) => {
  const { tr } = useTranslationLgs();

  if (!contracted?.rows?.length) {
    return <span data-testid={dataTestId}>-</span>;
  }

  return (
    <span className="flex flex-col" data-testid={dataTestId}>
      {contracted.rows.map((row, idx) => (
        <span key={`${row.cargoTemplateCode}-${idx}`} data-testid={`${dataTestId}-row-${idx}`} data-cargo-template-code={row.cargoTemplateCode}>
          {`${row.cargoTemplateName || row.cargoTemplateCode}: `}
          {isNullOrUndefined(row.unitPrice) ? (
            <span className="text-content-error">{tr('carrier.demand.quote.contracted.missingPrice', 'Chybí smluvní cena')}</span>
          ) : (
            <>
              {tr('carrier.demand.quote.contracted.unitPrice', '{{price}} / jedn.', {
                price: formatPrice(row.unitPrice, row.currency ?? contracted.currency),
              })}{' '}
              (
              {isNullOrUndefined(row.matchedLadenFactor)
                ? tr('carrier.demand.quote.contracted.defaultRow', 'Výchozí')
                : tr('carrier.demand.quote.contracted.ladenFactorRow', 'Ladenfactor {{ladenFactor}}', {
                    ladenFactor: row.matchedLadenFactor,
                  })}
              )
            </>
          )}
        </span>
      ))}
    </span>
  );
};

export default ContractedPriceRows;
